{
    "PageTitle_auth": "Authentifizierung",
    "NAME": "Router",
    "PageTitle_presence": "Anwesenheit",
    "PageTitle_changePassword": "Kennwort ändern",
    "PageTitle_forgotPassword": "Passwort vergessen",
    "PageTitle_changeLanguage": "Sprache ändern",
    "PageTitle_resetPassword": "Passwort zurücksetzen",
    "PageTitle_termsAndConditions": "Geschäftsbedingungen",
    "PageTitle_cookiePolicy": "Cookie-Richtlinie",
    "PageTitle_privacyPolicy": "Datenschutzrichtlinie",
    "PageTitle_mfa": "Multi-Faktor-Authentifizierung",
    "PageTitle_teamsAuth": "Teams-Authentifizierung",
    "PageTitle_insights": "Einblicke",
    "PageTitle_crmIntegration": "CRM-Integration",
    "PageTitle_changeUserAgent": "Benutzeragent ändern",
    "PageTitle_clientConfiguration": "Client-Konfiguration",
    "PageTitle_CRMConfiguration": "CRM-Konfiguration",
    "PageTitle_adminControl": "Administratorsteuerung"
}